import client from "./client";
import axios from "axios";

export const addrSearch = (keyword) =>
    axios.get('https://www.juso.go.kr/addrlink/addrLinkApi.do', {
        params: {
            confmKey: 'U01TX0FVVEgyMDE4MDcwNDEwNTcxNTEwNzk4MTc=',
            resultType: 'json',
            keyword
        }
    });
